const EVENT_ROWS = [
	{ key: 'Wedding', label: 'Свадьба' },
	{ key: 'Birthday', label: 'День рождения' },
	{ key: 'Corporate_NY', label: 'Новый год' },
	{ key: 'Corporate', label: 'Корпоратив' },
];

const getCount = (counts, eventKey, year) => counts[eventKey]?.[year] ?? 0;

/**
 * Maps company.eventSelections (3 years) to TableValuation cols/rows.
 * One value per year column.
 * @param {Array<{ year: number, events?: Array<{ key?: string, selectionCount?: number }> }>} eventSelections
 */
export const mapEventSelectionsToTableValuation = (eventSelections = []) => {
	const years = (eventSelections ?? [])
		.map((item) => item?.year)
		.filter((year) => Number.isFinite(year));

	if (!years.length) {
		return null;
	}

	const counts = {};

	for (const { year, events } of eventSelections) {
		for (const event of events ?? []) {
			if (!event?.key) continue;

			counts[event.key] ??= {};
			counts[event.key][year] = event.selectionCount ?? 0;
		}
	}

	const olderYears = years.slice(0, -1);
	const latestYear = years[years.length - 1];
	const rangeLabel =
		olderYears.length > 1
			? `${olderYears[0]}-${olderYears[olderYears.length - 1]}`
			: olderYears.length === 1
				? String(olderYears[0])
				: null;

	const cols = [
		{ id: 'event', labels: [{ id: 'event' }] },
		...years.map((year) => ({
			id: String(year),
			label: String(year),
			labels: [{ id: String(year) }],
		})),
	];

	const rows = EVENT_ROWS.map((event, index) => {
		const row = {
			id: index,
			event: event.label,
		};

		years.forEach((year) => {
			row[String(year)] = String(getCount(counts, event.key, year));
		});

		return row;
	});

	return { cols, rows };
};
